import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { ConsultationService } from "@customTypes/consultation";


export const useUpdateClinicTreatmentPlan = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      treatmentPlanId,
      treatmentPlan,
    }: {
      treatmentPlanId: string;
      treatmentPlan: Partial<ConsultationService>;
    }) => {
      return api.put(`clinic/treatment-services/${treatmentPlanId}`, {
        name: treatmentPlan.name,
        category: treatmentPlan.category,
        price: treatmentPlan.price,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-treatment-plan-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.treatmentPlans(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Clinic Treatment Plan]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.treatmentPlans(),
      });

      handleErrors(res, "mutation");
    },
  });
};
